function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRemovei = function SvgRemovei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M6.817 2.5h9.101c.79 0 1.445.653 1.445 1.475v2.499a.731.731 0 0 1-1.461 0V3.975c0-.009.024-.013.016-.013h-7.66v1.767c0 .815-.66 1.475-1.473 1.475H4.998v12.82c0 .01-.025.015-.016.015H15.9l.003-.014v-2.541a.732.732 0 0 1 1.461 0v2.54c0 .823-.655 1.476-1.445 1.476H4.982c-.79 0-1.446-.653-1.446-1.475V5.83l.001-.027a.72.72 0 0 1 .214-.54l2.55-2.55a.74.74 0 0 1 .516-.214m8.782 9.5-2.583-2.584a.73.73 0 1 1 1.033-1.033l2.584 2.583 2.584-2.583a.73.73 0 1 1 1.032 1.033L17.666 12l2.583 2.584a.73.73 0 1 1-1.032 1.033l-2.584-2.583-2.584 2.583a.73.73 0 1 1-1.033-1.033zM6.797 4.284 5.34 5.743h1.446q.01-.001.012-.014z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRemovei);
export default ForwardRef;